import React from 'react';
import classNames from 'classnames';
import { DropdownPortal } from '../../dropdown-portal';

interface AddSeriesModalProps {
  children: React.ReactNode;
  onClose: () => void;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  className?: string;
  dropdownClassName?: string;

  anchorEl?: HTMLElement | null;
}

const AddSeriesModal: React.FC<AddSeriesModalProps> = ({
  children,
  onClose,
  isOpen,
  setIsOpen,
  className = '',
  dropdownClassName = '',
  anchorEl,
}) => {
  const dropdownClassname = classNames('add-dropdown-class', dropdownClassName);
  const modalClassname = classNames('add-series-modal', className);

  return (
    <DropdownPortal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      classNames={dropdownClassname}
      onClose={onClose}
      anchorEl={anchorEl}
    >
      <div className={modalClassname}>{children}</div>
    </DropdownPortal>
  );
};

export default AddSeriesModal;
